export const getWorkCenterByIdInitialState = {
	workCenter: null,
	error: null,
	errorShow: false,
	loading: false,
};
